module.exports = __webpack_public_path__ + "static/media/search.de15e9fe.svg";